import { Main } from './Main/Main'

function App() {
  return <Main />
}

export default App
